module.exports = __webpack_public_path__ + "static/media/line-columns.2d8736c1.svg";